import { Component, OnInit, Inject, ViewChild, Optional, OnDestroy, HostListener, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioButton } from '@angular/material/radio';
import { MatCheckbox } from '@angular/material/checkbox';
import { Subject } from 'rxjs';
import { saveAs } from 'file-saver';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { CookieService } from 'ngx-cookie-service';
import { LoggingService } from '@EfsServices/logging.service';
import { DataSharingService } from '@efsShared/services/data-sharing.service';
import { EfsApiService } from '@EfsServices/efs-api.service';
import { environment } from '@efsEnvironments/environment';
import { GenericPopupComponent } from '@EfsReusable/generic-popup/generic-popup.component';
import { ApiErrorHandlingService } from '@EfsServices/api-error-handling.service';
import { SessionTimerService } from '@EfsServices/session-timer.service';
import { PermissionHandlingService } from '@efsShared/services/permission-handling.service';

@Component({
  selector: 'app-corp-profile-setup',
  templateUrl: './corp-profile-setup.component.html',
  styleUrl: './corp-profile-setup.component.css',
  standalone: false
})
export class CorpProfileSetupComponent {
  corpProfileSetupTitle = 'Corp Profile Setup';
  addOrUpdateImm = 'Add IMM';

  showAddIMMButton = true;
  showModifyIMMButton = true;
  showProfileRecipeDetailsCard = false;
  showExcelUploadButton = true;

  addIMMDisable = false;
  modifyIMMDisable = true;
  excelUploadDisable = false;

  selectedProfileControl = new UntypedFormControl({ value: '', disabled: false }, [
  ]);

  // controls for the form to add/modify profile recipes
  profileRecipeIdControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.required,
    Validators.pattern('^[a-zA-Z0-9_-]+$')
  ]);
  profileNmControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.required,
    Validators.pattern('^[a-zA-Z0-9_-]+$')
  ]);
  immControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.required,
    Validators.pattern('^[a-zA-Z0-9_-]+$')
  ]);
  recipeFoldControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.required,
    Validators.pattern('^[0-9]*\.?[0-9]+$')
  ]);
  foldXCoordControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.required,
    Validators.pattern('^[0-9]*\.?[0-9]+$')
  ]);
  foldYCoordControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.required,
    Validators.pattern('^[0-9]*\.?[0-9]+$')
  ]);
  recipeRollControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.required,
    Validators.pattern('^[0-9]*\.?[0-9]+$')
  ]);
  rollXCoordControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.required,
    Validators.pattern('^[0-9]*\.?[0-9]+$')
  ]);
  rollYCoordControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.required,
    Validators.pattern('^[0-9]*\.?[0-9]+$')
  ]);


  selectedProfiles: any[] = [];
  uniqueSelectedProfiles: any[] = [];
  selectedRow: any = null;

  uploadStatusResults: any;
  popupDialogRef: any;

  constructor(
    public permissionHandlingService: PermissionHandlingService,
    private efsApiService: EfsApiService,
    private router: Router,
    private route: ActivatedRoute,
    public dataSharingService: DataSharingService,
    public dialog: MatDialog,
    public loggingService: LoggingService,
    private apiErrorHandlingService: ApiErrorHandlingService,
  ) { }

  ngOnInit() {
    if (this.permissionHandlingService.permissionsMap.get('EFS-PROD METHOD GROUP WRITE')) {
      // this.writeMode = true;
    } else {
      // this.writeMode = false;
    }
    this.serviceGetProfileRecipes();


  }

  // services
  serviceGetProfileRecipes() {
    this.efsApiService.getProfileRecipes().subscribe(
      {
        next: (response: any) => {
          console.log(JSON.stringify(response));
          this.selectedProfiles = response;
          this.uniqueSelectedProfiles = this.getUniqueProfilesByName(response);

          if (this.selectedProfileControl.value?.profileNm) {
            const matchingProfile = this.uniqueSelectedProfiles.find(
              profile => profile.profileNm === this.selectedProfileControl.value.profileNm
            );

            this.selectedProfileControl.setValue(matchingProfile || '');
          }
        },
        error: (error) => {
          this.apiErrorHandlingService.errorStatusHandler(error);
        }
      });
  }

  getUniqueProfilesByName(profiles: any[]) {
    const seenProfileNames = new Set();

    return (profiles || []).filter(profile => {
      const profileName = profile?.profileNm;

      if (!profileName || seenProfileNames.has(profileName)) {
        return false;
      }

      seenProfileNames.add(profileName);
      return true;
    });
  }

  formatRevDate(date: string) {
    if (date === null || date === '' || date === undefined || date === 'undefined') {
      return '';
    }

    const formattedDate = date.slice(0, 14);
    const datePortion = formattedDate.slice(0, 8);
    const timePortion = formattedDate.slice(8, 14);

    const readableDate = datePortion.slice(0, 2) +
      '/' + datePortion.slice(2, 4) +
      '/' + datePortion.slice(4, 8);

    if (timePortion.length < 6) {
      return readableDate;
    }

    return readableDate +
      ' ' + timePortion.slice(0, 2) +
      ':' + timePortion.slice(2, 4) +
      ':' + timePortion.slice(4, 6);
  }

  uploadExcelService(spreadsheetFormData) {
    this.efsApiService.addProfileRecipeSpreadsheetToEfs(spreadsheetFormData).subscribe(response => {
      console.log('upload corp profile response stringify: ' + JSON.stringify(response));
      console.log('upload corp profile response raw: ' + response);
      this.uploadStatusResults = response; // map accordingly
      // show popup with results
      this.popupWarning(false, 'Succesfully uploaded spreadsheet.');
      this.serviceGetProfileRecipes();

      // this.showCorpStatus = true;
      // this.useSpinner = false;
    }, error => {
      this.popupWarning(false, 'Failed to upload spreadsheet.');
      // this.useSpinner = false;
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }

  // end of services

  addImmButton() {
    this.resetForm();
    this.showProfileRecipeDetailsCard = true;
    this.addOrUpdateImm = 'Add IMM';
    this.profileRecipeIdControl.disable();
  }

  modifyImmButton() {
    this.showProfileRecipeDetailsCard = true;
    this.addOrUpdateImm = 'Modify IMM';
    this.profileRecipeIdControl.disable();

  }

  /**
   * take data from form and call service to add or modify profile recipe depending on which button was clicked. If add button was clicked, call add service, if modify button was clicked, call modify service
   */
  saveFormButton() {
    if (this.profileRecipeIdControl.invalid || this.profileNmControl.invalid || this.immControl.invalid || this.recipeFoldControl.invalid || this.foldXCoordControl.invalid || this.foldYCoordControl.invalid || this.recipeRollControl.invalid || this.rollXCoordControl.invalid || this.rollYCoordControl.invalid) {
      this.popupWarning(false, 'Please fill out all fields with valid values before saving.');
      return;
    }

    const profileRecipeBody = {
      profileRecipeId: this.profileRecipeIdControl.value,
      profileNm: this.profileNmControl.value,
      imm: this.immControl.value,
      recipeFold: this.recipeFoldControl.value,
      foldXCoord: this.foldXCoordControl.value,
      foldYCoord: this.foldYCoordControl.value,
      recipeRoll: this.recipeRollControl.value,
      rollXCoord: this.rollXCoordControl.value,
      rollYCoord: this.rollYCoordControl.value
    };
    if (this.addOrUpdateImm === 'Add IMM') {
      // call add service
      this.efsApiService.addProfileRecipe(profileRecipeBody).subscribe(
        {
          next: (response: any) => {
            console.log('Profile recipe added successfully:', response);
            this.resetForm();
            this.serviceGetProfileRecipes();

            this.popupWarning(false, 'Profile recipe added successfully.');
          },
          error: (error) => {
            this.apiErrorHandlingService.errorStatusHandler(error);
          }
        }
      );
    }
    else if (this.addOrUpdateImm === 'Modify IMM') {
      // call modify service
      this.efsApiService.updateProfileRecipe(profileRecipeBody).subscribe(
        {
          next: (response: any) => {
            console.log('Profile recipe modified successfully:', response);
            this.resetForm();
            this.serviceGetProfileRecipes();
            this.popupWarning(false, 'Profile recipe modified successfully.');
          },
          error: (error) => {
            this.apiErrorHandlingService.errorStatusHandler(error);
          }
        }
      );
    }

  }

  onFileSelected(event) {
    // start loading spinner
    // this.useSpinner = true;
    console.log('is this going off? file upload');
    console.log(JSON.stringify(event));
    const file: File = event.target.files[0];
    console.log(file);

    if (file) {
      this.getBase64(file);
    }
    event.target.value = '';
  }

  getBase64(file) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {

      let base64result = (<string>reader.result).split(',')[1];

      const uploadJson = {
        spreadsheet: base64result
      };
      this.uploadExcelService(uploadJson);

    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  onProfileChange() {
    this.selectedRow = null;
    this.modifyIMMDisable = true;
    this.showProfileRecipeDetailsCard = false;
  }

  onRowClick(row) {
    this.selectedRow = row;
    this.modifyIMMDisable = false;
    this.populateForm(row);
    this.showProfileRecipeDetailsCard = false; // when a row is clicked remove the details card until modify button is clicked
  }

  populateForm(row) {
    console.log('ROW TO POPULATE FORM: ' + JSON.stringify(row));
    this.profileRecipeIdControl.setValue(row.profileRecipeId);
    this.profileNmControl.setValue(row.profileNm);
    this.immControl.setValue(row.imm);
    this.recipeFoldControl.setValue(row.recipeFold);
    this.foldXCoordControl.setValue(row.foldXCoord);
    this.foldYCoordControl.setValue(row.foldYCoord);
    this.recipeRollControl.setValue(row.recipeRoll);
    this.rollXCoordControl.setValue(row.rollXCoord);
    this.rollYCoordControl.setValue(row.rollYCoord);
  }

  resetForm() {
    this.profileRecipeIdControl.reset();
    this.profileNmControl.reset();
    this.immControl.reset();
    this.recipeFoldControl.reset();
    this.foldXCoordControl.reset();
    this.foldYCoordControl.reset();
    this.recipeRollControl.reset();
    this.rollXCoordControl.reset();
    this.rollYCoordControl.reset();
    this.selectedRow = null;
    this.modifyIMMDisable = true;
    this.showProfileRecipeDetailsCard = false;
  }

  popupWarning(questionType, message, useSpinner?) {
    this.popupDialogRef = this.dialog.open(GenericPopupComponent, {
      width: '450px',
      height: '250px',
      panelClass: 'popup-borders',
      data: {
        questionType,
        title: 'Alert',
        message,
        useSpinner
      }
    });
    // return true;
  }


}
